import React from "react";
import FoodCard from "./common/FoodCard";
import SearchCategories from "./SearchCategories";
import SearchFilterBtn from "./SearchFilterBtn";
import SearchHeader from "./SearchHeader";
import SortedData from "../data/data.json";

const AZ = () => {
  return (
    <div>
      <SearchHeader />
      <SearchFilterBtn />
      <SearchCategories />
      <FoodCard
        data={SortedData.sort((a, b) => a.itemName.localeCompare(b.itemName))}
      />
    </div>
  );
};

export default AZ;
